import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { forwardRef } from 'react';
import { Badge, Space } from 'udesk-ui';
import { ContentHeader, RoleTag } from './components';
import XssComponent from 'udesk-react/src/components/xss';
import { replaceLineBreak } from 'src/util/text-replace';

interface TemplateProps {
    item?: any;
    content?: any;
    titleRef?: any;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, content, titleRef } = props;

    const locales = UdeskLocales['current'];

    const { data = {} } = item;

    return (
        <div>
            <ContentHeader>
                <Space>
                    <div style={{ fontWeight: 600 }}>{data.sendUser}</div>
                    <RoleTag sender={data.sender}>
                        {data.sender === 1 || data.sender === '1'
                            ? /* 客户 */ locales.components.ticketTextInfo.index.customer
                            : /* 客服 */ locales.components.ticketTextInfo.index.customerService}
                    </RoleTag>
                </Space>

                <div className="desc" ref={titleRef}>
                    {`${data.createdTime} ${/* 发送短信 */UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.sendSMS}`}
                </div>
            </ContentHeader>

            <div style={{ marginBottom: 16 }}>
                <div>{/* 基础信息： */}{UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.basicInformation}</div>
                <div>
                    <Space wrap>
                        <Badge status="default" text={`${/* 手机号： */UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.mobilePhoneNumber}${data.smsPhoneNum || '-'}`} />
                        <Badge status="default" text={`${/* 发送对象： */UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.sendObject}${data.smsSendTarget || '-'}`} />
                        <Badge status="default" text={`${/* 短信模板： */UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.sMSTemplate}${data.smsTemplate || '-'}`} />
                        <Badge status="default" text={`${/* 发送结果： */UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.sendResults}${data.smsSendResult || '-'}`} />
                    </Space>
                </div>
            </div>

            <div>
                <div>{/* 短信内容： */}{UdeskLocales['current'].components.ticketTextInfo.components.textMessage.index.sMSContent}</div>
                <div ref={ref}>
                    <XssComponent
                        whiteList={Udesk.ui.widgets.xss.whiteLists.email}
                        value={replaceLineBreak(content)}
                    />
                </div>
            </div>
        </div>
    );
});

export default Template;
